// src/sections/Skills.js
import React, { useState } from 'react';
import styled from 'styled-components';
import { colors, space } from '../styles/tokens';
import { SectionHeading } from '../components/SectionHeading';
import { skills } from '../data/skills';

const Skills = () => {
  const [isActive, setIsActive] = useState(false);
  const toggleMenu = () => setIsActive(!isActive);

  return (
    <StyledSection id="skills" aria-labelledby="skills-heading">
      <SectionHeading prefix="skills" id="skills-heading" center size="xl">Skills</SectionHeading>
      <ul className={`menu ${isActive ? 'active' : ''}`} onClick={toggleMenu}>
        <li className="menu-toggle" aria-label={isActive ? 'Collapse skills' : 'Expand skills'}>+</li>
        {skills.map((item, index) => (
          <li className="inner-list" key={item.text} style={{ '--i': index }}>
            <div style={{ '--color': item.color }}>
              <img className="inner-image" src={item.image} alt={item.imageDescription} />
              {item.text}
            </div>
          </li>
        ))}
      </ul>
    </StyledSection>
  );
};

const StyledSection = styled.section`
  padding: ${space[12]} ${space[4]};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img.inner-image {
    height: 3.25rem;
    width: 3.25rem;
    background-size: contain;
  }

  .menu {
    width: 26rem;
    height: 26rem;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .menu .inner-list {
    position: absolute;
    left: 0;
    list-style: none;
    transform-origin: 13rem;
    transition: 0.3s;
    transition-delay: calc(0.1s * var(--i));
    transform: rotate(0deg) translate(10rem);
  }

  .menu.active li {
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    transform: rotate(calc(360deg / 8 * var(--i)));
  }

  .menu .inner-list div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90px;
    height: 90px;
    text-align: center;
    color: transparent;
    flex-direction: column;
    gap: 0.25rem;
    font-size: 0.75rem;
    line-height: 1.1;
    transform: rotate(calc(360deg / -8 * var(--i)));
    img { opacity: 0; }
  }

  .menu.active li div {
    color: var(--color);
    img { opacity: 1; transition: opacity 3s; }
  }

  .menu .inner-list div::before {
    content: '';
    position: absolute;
    width: 3rem;
    height: 0.125rem;
    border-radius: 0.125rem;
    background-color: var(--color);
    transform: rotate(calc(var(--i) * 90deg)) translate(0, 3.25rem);
    transition: height 0.5s, width 0.5s, transform 0.5s;
    transition-delay: 0s, 0s, 0s;
  }

  .menu.active li div::before {
    content: '';
    position: absolute;
    width: 6rem;
    height: 6rem;
    border: 0.125rem solid var(--color);
    box-sizing: border-box;
    background: ${colors.bgElev};
    transform: rotate(calc(var(--i) * 90deg)) translate(0, 0);
    transition: transform 0.5s, width 0.5s, height 0.5s;
    transition-delay: 1s, 1.5s, 1.5s;
    rotate: 135deg;
    z-index: -2;
  }

  .menu.active li:hover div::before {
    z-index: -100;
    color: black;
    background-color: var(--color);
    box-shadow: 0 0 10px var(--color);
  }
  .menu.active li:hover div img { filter: brightness(0) grayscale(100%); }
  .menu.active li:hover div {
    position: relative;
    transition: 0.1s;
    color: black;
    z-index: 10;
  }

  .menu .inner-list div::after {
    content: '';
    position: absolute;
    left: 6.5rem;
    width: 3rem;
    height: 0.125rem;
    border-radius: 0.125rem;
    background-color: var(--color);
    z-index: -100;
    transform: rotate(calc(var(--i) * 0deg)) translate(0.625rem, 0);
    transition: 0.5s;
    transition-delay: 0.5s;
  }

  .menu.active li div::after {
    content: '';
    left: 0;
    width: 5.75rem;
    transform: rotate(calc(var(--i) * 45deg)) translate(2.75rem, 0);
    transition-delay: 0.5s;
  }

  .menu-toggle {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 6rem;
    height: 6rem;
    z-index: 1000;
    color: #fff;justify-content: center;
    align-items: center;
    width: 90px;
    height: 90px;
    cursor: pointer;
    font-size: 2em;
    transition: transform 1.5s;
    box-sizing: border-box;
    list-style: none;
  }

  .menu:not(.active) .menu-toggle { margin-left: -0.3rem; }

  .menu.active .menu-toggle { transform: rotate(315deg); }

  @media (max-width: 550px) {
    img.inner-image { height: 1.75rem; width: 1.75rem; }
    .menu .inner-list div { font-size: 0.5em; }

    .menu { width: 16.25rem; height: 16.25rem; }

    .menu .inner-list {
      left: 0;
      transform-origin: 8.125rem;
      transform: rotate(0deg) translate(6.25rem);
    }

    .menu .inner-list div { width: 3.75rem; height: 3.75rem; }

    .menu .inner-list div::before {
      width: 1.25rem;
      height: 0.125rem;
      transform: rotate(calc(var(--i) * 90deg)) translate(0, 1.563rem);
    }
    .menu.active li div::before {
      width: 3.75rem;
      height: 3.75rem;
      transform: rotate(calc(var(--i) * 90deg)) translate(0, 0);
      rotate: 135deg;
    }
    .menu .inner-list div::after {
      left: 3.125rem;
      width: 1.25rem;
      height: 0.125rem;
      transform: rotate(calc(var(--i) * 0deg)) translate(0.625rem, 0);
    }
    .menu.active li div::after {
      left: 0.625rem;
      width: 2.5rem;
      transform: rotate(calc(var(--i) * 45deg)) translate(3.125rem, 0);
    }
    .menu-toggle { width: 3.75rem; height: 3.75rem; font-size: 2em; padding-bottom: 0.5rem; }
  }
`;

export default Skills;
